"use strict";

require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _paulCorePackage = require("paul-core-package");
var _TemperatureCircleModule = _interopRequireDefault(require("../../styles/components/Circles/TemperatureCircle.module.css"));
var _Circles = _interopRequireDefault(require("./Circles"));
var _Timestamp = _interopRequireDefault(require("./Timestamp"));
var _Value = _interopRequireDefault(require("./Value"));
var _useGetValue = require("../../hooks/useGetValue");
var _CircleTitle = _interopRequireDefault(require("./CircleTitle"));
var _constants = require("../../utils/constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const TemperatureCircle = _ref => {
  let {
    thingPDIDDevice,
    displayNameId,
    hasPositionValue = false,
    hover = false
  } = _ref;
  const [temperature] = (0, _useGetValue.useGetValueParamsByDisplayNameId)({
    displayNameId,
    thingPDIDDevice,
    params: [_constants.valueParamsName.value]
  });
  const isCorrectTemperature = (0, _react.useMemo)(() => _paulCorePackage.functions.getIsCorrectTemperature(temperature), [temperature]);
  return (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(_TemperatureCircleModule.default.container, " flex-center")
  }, /*#__PURE__*/_react.default.createElement(_Circles.default, {
    thingPDIDDevice: thingPDIDDevice,
    isCorrectValue: isCorrectTemperature,
    displayNameId: displayNameId,
    type: _constants.circleType.temperature
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: _TemperatureCircleModule.default.temperature
  }, hasPositionValue && /*#__PURE__*/_react.default.createElement(_CircleTitle.default, {
    displayNameId: displayNameId,
    hover: hover,
    isPositionValue: true
  }), /*#__PURE__*/_react.default.createElement(_Value.default, {
    thingPDIDDevice: thingPDIDDevice,
    isCorrect: isCorrectTemperature,
    displayNameId: displayNameId
  }), /*#__PURE__*/_react.default.createElement(_Timestamp.default, {
    thingPDIDDevice: thingPDIDDevice,
    isCorrect: isCorrectTemperature,
    displayNameId: displayNameId,
    hover: hover
  }))), [isCorrectTemperature, thingPDIDDevice, hover, hasPositionValue]);
};
var _default = exports.default = TemperatureCircle;